import React from 'react';
import LegendPopulation from './LegendPopulation';
import LegendRent from './LegendRent';

const Map = ({ url, population }) => (
  <div>
    {population ? <LegendPopulation />
                : <LegendRent />}

    <img src={url} alt="map" />
  </div>
);

export default Map;